import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

export function initSwiper() {
  // ページ内のすべてのスライダー要素を取得
  const swiperContainers = document.querySelectorAll(
    '[data-swiper="creation"]'
  );

  // 各スライダー要素に対して初期化処理を実行
  swiperContainers.forEach((swiperContainer) => {
    // スライダーの親要素から関連要素（ページ番号、ナビゲーションボタン）を取得
    // HTML構造の変更に対応。swiperContainerの中から各要素を直接検索する
    const slideNums = swiperContainer.querySelectorAll(
      '.p-office-creation__item-num'
    );
    const nextButton = swiperContainer.querySelector('.swiper-button-next');
    const prevButton = swiperContainer.querySelector('.swiper-button-prev');
    const border = swiperContainer.querySelector(
      '.p-office-creation__item-border'
    ); // ボーダー要素を取得

    // ページ番号のクラス（current）を更新する関数
    const updatePager = (swiper) => {
      slideNums.forEach((num, index) => {
        // 現在のスライドのインデックスと一致する場合のみ 'current' クラスを付与
        num.classList.toggle('current', index === swiper.realIndex);
      });

      // 2枚目のスライドが表示されている場合にボーダーにクラスを付与
      if (border) {
        border.classList.toggle('is-active', swiper.realIndex === 1);
      }
    };

    const creationSwiper = new Swiper(swiperContainer, {
      modules: [Navigation, Autoplay],
      loop: true, // ループ有効化
      loopFillGroupWithBlank: true, // 2枚のスライドでもループをサポート
      slidesPerView: 1, // 1枚ずつ表示
      speed: 1500,
      spaceBetween: 25,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },

      // ナビゲーションボタンの要素を直接指定
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        // Swiperの初期化が完了した時と、スライドが切り替わった時にページャーを更新
        init: updatePager,
        slideChange: updatePager,
      },
    });
  });
}
